import Home from "../components/Home";
import Card from "../components/Card";

export const routes = [
  { path: "/", name: "home", component: Home },
  { path: "/:card", name: "card", component: Card },
];
